import { Component, OnInit,  OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
//import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../utils/services/api.service';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-voucher-list',
  templateUrl: './add-voucher-list.component.html',
  styleUrls: ['./add-voucher-list.component.scss']
})
export class AddVoucherListComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  private category: string;
  public allData: any;
  public editCatRoute: string;
  public addLanName: string;
  public addLanRoute: string;
  id: any;
  private isDtInitialized: boolean = false;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;


  constructor(  private router: Router,
    private apiService: ApiService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    //console.log("HEllo")
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.coupan();
  }

  coupan() {
    // console.log(this.addLanguageListForm.value)
    this.apiService.voucherList().subscribe((resp: any) => {
      console.log(resp,"responnnnnn");
      this.allData = resp.data;
      if (this.isDtInitialized) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
        });
      } else {
        this.isDtInitialized = true;
        this.dtTrigger.next();
      }
    });
  }

  async videolist(id, status) {
    if (id == undefined || id == '') {
      //this.toastr.error(' Id is Invalid');
      Swal.fire({
        text: 'Id is Invalid',
        icon: 'error',
      });
      return false;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'Are you sure, you want to change status?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        let getStatus = {};
        getStatus =
          status === 'active' ? { status: 'inactive' } : { status: 'active' };
        this.apiService
          .coupanStatus(id, JSON.stringify(getStatus))
          .subscribe((result: any) => {
            if (result.success) {
              Swal.fire({
                text: result.message,
                icon: 'success',
              });
              //this.toastr.success(result.message);
              this.coupan();
            } else {
              Swal.fire({
                text: result.message,
                icon: 'error',
              });
              //this.toastr.error(result.message);
            }
          });
      }
    });
  }

  deletecoupon(id){
    console.log(id);
    if (id == undefined || id == '') {
      //this.toastr.error(' Id is Invalid');
      Swal.fire({
        text: 'Id is Invalid',
        icon: 'error',
      });
      return false;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: 'Are you sure, you want to delete voucher?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
       if (result.isConfirmed) {
       this.apiService.deleteCouponById(id).subscribe((res: any) => {
        // console.log(res);
        if (res.success) {
          Swal.fire({
              text: 'Voucher delete sucessfully',
              icon: 'success',
            });
          //this.toastr.success(res.message);
           this.coupan();
        } else {
           Swal.fire({
              text: res.message,
              icon: 'error',
            });
          //this.toastr.error(res.message);
        }
      });
      // else {
      //   return;
      // }
    }
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
